import { Injectable } from '@angular/core';

@Injectable()
export class HelpersService {

  constructor() { }

  isEmpty(obj) {
    var isObj = obj !== null 
    && typeof obj === 'object' 
    && Object.prototype.toString.call(obj) === '[object Object]';

    if (isObj) {
        for (var o in obj) {
            if (obj.hasOwnProperty(o)) {
                return false;
            }
        }
        return true;
    }
  }
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/helpers/helpers.service.ts